<template>
  <div class="about">
    <h1 class="page-header">אודות קרן נאמן</h1>

    <div class="card card-row shadow-light-lg mb-6">
      <div class="row no-gutters">
        <div
          class="col-12 col-md-6 order-md-2 bg-cover card-img-right did-you-know"
        >
          <img
            :src="require('../assets/img/charity_growth.jpg')"
            alt="..."
            class="img-fluid d-md-none invisible"
          />
          <div
            class="shape shape-left shape-fluid-y svg-shim text-white d-none d-md-block"
          >
            <svg
              viewBox="0 0 112 690"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 0h62.759v172C38.62 384 112 517 112 517v173H0V0z"
                fill="currentColor"
              ></path>
            </svg>
          </div>
        </div>
        <div class="col-12 col-md-6 order-md-1">
          <div class="card-body">
            <h2>הידעת…</h2>
            <template v-if="$store.state.country == 'us'">
              <p class="text-muted">
                היקף התמיכה מקנדה והנדיבות האמריקאית גדלו והתעצמו במענה לצרכים
                הגדלים והולכים של החברה בישראל.
              </p>
              <p class="text-muted">
                כעת, ישנו ארגון אמריקאי המייחד את פעילותו לשם יצירת חיבור פיננסי
                איתן בין שתי המדינות ובנוסף, גם לסיוע לארגונים ומלכ”רים בישראל,
                בבניית בסיס תורמים חדש בארה”ב או לחיזוקו של בסיס תורמים קיים.
              </p>
            </template>
            <template v-else>
              <p class="text-muted">
                היקף התמיכה מקנדה והנדיבות הקנדית גדלו והתעצמו במענה לצרכים
                הגדלים והולכים של החברה בישראל.
              </p>
              <p class="text-muted">
                כעת, ישנו ארגון קנדי המייחד את פעילותו לשם יצירת חיבור פיננסי
                איתן בין שתי המדינות ובנוסף, גם לסיוע לארגונים ומלכ”רים בישראל,
                בבניית בסיס תורמים חדש בקנדה או לחיזוקו של בסיס תורמים קיים.
              </p>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="card card-row shadow-light-lg mb-6">
      <div class="row no-gutters">
        <div
          class="col-12 col-md-6 bg-cover card-img-left who-we"
          :style="{
            backgroundImage: 'url(' + bgImage + ')',
          }"
        >
          <div
            class="shape shape-right shape-fluid-y svg-shim text-white d-none d-md-block"
          >
            <svg
              viewBox="0 0 112 690"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M116 0H51v172C76 384 0 517 0 517v173h116V0z"
                fill="currentColor"
              ></path>
            </svg>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="card-body">
            <h2>מי אנחנו</h2>
            <template v-if="$store.state.country == 'us'">
              <p class="text-muted">
                קרן נאמן, באמצעות המשרדים שלה במסצ’וסטס ובישראל, מציעה לתורמים
                אמריקאים מבחר נרחב של מיזמים בישראל. המיזמים מוכרים לצרכי מס,
                נמצאים תחת פיקוח ובקרה אשר מבטיחים כי הכספים משמשים לקיום המטרות
                שהוקצו והוגדרו, ועומדים בדרישות חוקי המס של ארה”ב.
              </p>
              <p class="text-muted">
                קרן נאמן מבטיחה העברת הכספים לישראל בתוך זמן קצר ובכך מאפשרת
                למלכ”רים ישראליים ליישם את המיזמים שלהם בהקדם האפשרי.
              </p>
              <p class="text-muted">
                קרן נאמן מבטיחה שקיפות מלאה גם לתורמים וגם לעמותה כך שהתורמים
                ידעו בדיוק כיצד משתמשים במענק שלהם.
              </p>
            </template>
            <template v-else>
              <p class="text-muted">
                קרן נאמן, באמצעות המשרדים שלה בטורונטו ובישראל, מציעה לתורמים
                קנדיים מבחר נרחב של מיזמים בישראל. המיזמים מוכרים לצרכי מס,
                נמצאים תחת פיקוח ובקרה אשר מבטיחים כי הכספים משמשים לקיום המטרות
                שהוקצו והוגדרו, ועומדים בדרישות חוקי המס של קנדה.
              </p>
              <p class="text-muted">
                קרן נאמן מבטיחה העברת הכספים לישראל בתוך זמן קצר ובכך מאפשרת
                למלכ”רים ישראליים ליישם את המיזמים שלהם בהקדם האפשרי.
              </p>
              <p class="text-muted">
                קרן נאמן מבטיחה שקיפות מלאה גם לתורמים וגם לעמותה כך שהתורמים
                ידעו בדיוק כיצד משתמשים במענק שלהם.
              </p>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="card card-row shadow-light-lg mb-6">
      <div class="row no-gutters">
        <div class="col-12 col-md-6 order-md-2 bg-cover card-img-right poverty">
          <img
            :src="require('../assets/img/poverty.jpg')"
            alt="..."
            class="img-fluid d-md-none invisible"
          />
          <div
            class="shape shape-left shape-fluid-y svg-shim text-white d-none d-md-block"
          >
            <svg
              viewBox="0 0 112 690"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 0h62.759v172C38.62 384 112 517 112 517v173H0V0z"
                fill="currentColor"
              ></path>
            </svg>
          </div>
        </div>
        <div class="col-12 col-md-6 order-md-1">
          <div class="card-body">
            <h2>מהי הפעילות שלנו</h2>

            <p class="text-muted">
              קרן נאמן תומכת במיזמים אשר מפחיתים או עוקרים עוני מן השורש; מקדמת
              חינוך, אמונה ואיכות חיים; הקרן גם מקדמת יוזמות צדקה למען פיתוח
              חברתי בקהילות בישראל. בנוסף , אנו תומכים בפרויקטים בכל רחבי הארץ
              המעניקים שירותי בריאות ומפיקים מוצרים המונעים ומטפלים באיומים
              חמורים לבריאות תקינה ; פרויקטים המספקים טיפול לנפגעי תאונות , וגם
              ייעוץ ותמיכה לאנשים עם סרטן . קרן נאמן תומכת גם בתוכניות המספקות
              שירותי אמבולנס ציבורי, פרמדיקים או שירותי כבאות.
            </p>
            <p class="text-muted">
              <b>האם הנכם עמותה ללא כוונת רווח הרשומה בישראל?</b>
            </p>
            <p class="text-muted">
              <b v-if="$store.state.country == 'us'">
                האם אתם מפעילים מיזמים ראויים שלתורמים אמריקאים יכול להיות בהם
                עניין?
              </b>
              <b v-else>
                האם אתם מפעילים מיזמים ראויים שלתורמים קנדיים יכול להיות בהם
                עניין?
              </b>
            </p>
            <p class="text-muted">
              <b> בואו והכירו פילנתרופיה קנדית. </b>
            </p>
            <p>
              <router-link to="/contact" class="text-reset"
                >נשמח להיות בקשר
              </router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="card" dir="rtl">
      <div class="card-body">
        <div class="row">
          <div class="col-2 d-none d-lg-block text-center">
            <div class="avatar avatar-xxl">
              <img
                src="../assets/img/haim_katz_neeman.jpg"
                alt="Chaim Katz"
                class="avatar-img rounded-circle"
              />
            </div>
            <p class="wp-caption-text">חיים כץ, מייסד ומנכ"ל קרן נאמן</p>
          </div>
          <div class="col-md-10">
            <h2>
              <strong>חיים כץ, מייסד ומנכ"ל קרן נאמן</strong>
            </h2>
            <p class="mb-0 text-muted">
              יליד קנדה ותושב ישראל מאז 1987, חיים מביא עמו ניסיון מוכח של כמעט
              40 שנה בשירות ציבורי וארגונים ללא מטרות רווח.
            </p>
            <p class="mb-0 text-muted">
              בשנות השמונים, חיים כיהן כמנכ"ל ארגון לעידוד עלייה לישראל בניו
              יורק בשיתוף עם הסוכנות היהודית. לאחר מכן מילא תפקידי ניהול פיננסי
              בכירים בעיריית ניו יורק.
            </p>
            <p class="mb-0 text-muted">
              לאחר עלייתו לארץ, חיים עבד עם ילדים בעלי צרכים מיוחדים, כיהן כמנהל
              כספים בחברת ביטוח במשך שבע שנים, ושימש כמנכ"ל היישוב שילה במשך חמש
              שנים. בשנת 2011 הקים את קרן נאמן, שמלווה כיום מעל 1,300 עמותות
              בישראל.
            </p>
            <p class="mb-0 text-muted">
              הניסיון והיכרות של חיים עם עולמות הארגונים ללא מטרות רווח בישראל
              ובצפון אמריקה מאפשרים לו להציע הדרכה מקצועית ושירות איכותי לקרן
              נאמן ולעמותות בישראל.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "About Us",
  metaInfo: {
    title: "אודות קרן נאמן",
  },
  components: {},
  computed: {
    bgImage() {
      return this.$store.state.country == "us"
        ? require("@/assets/img/boston.jpg")
        : require("@/assets/img/toronto.jpg");
    },
  },
};
</script>
<style lang="scss" scoped>
p,
h2,
h3 {
  direction: rtl;
  text-align: right;
}
.did-you-know {
  background-image: url("~@/assets/img/charity_growth.jpg");
}
.poverty {
  background-image: url("~@/assets/img/poverty.jpg");
}
.who-we {
  background-image: url("~@/assets/img/boston.jpg");
}
.page-header:before,
.page-header:after {
  content: " ";
  position: absolute;
  top: 50%;
  margin-right: -999em;
  height: 2px;
  width: 999em;
  border-top: 1px solid #ddd;
}
.page-header:after {
  right: auto;
  width: 999em;
  margin: 0 1em 0 0;
}
</style>